<template lang="">
  <div :style="styleComp" class="square">
      <div :style="styleComp" class="sq_box">
          <div @transitionend="transtionEnd" id="sq_dom" class="sq">
              <!-- <img :style="styleComp" class="sq_img" :src="square"/> -->
              <div v-for="(item,index) in list" :key="index" class="box" :style="{left:px2rem(item.x)+'rem',top:px2rem(item.y)+'rem',width:px2rem(width)+'rem',height:px2rem(height)+'rem'}">
                <img src="https://source.qunarzz.com/site/images/wns/20220725-shijianchen-game-3.png"/>
              </div>
          </div>
          <span @click="onClickLottery" :style="`${lotteryStyle};width:${px2rem(width)}rem;height:${px2rem(height)}rem;`" class="sq_lott"><slot></slot></span>
          <div v-if="!isFirstOper" :data-value="value" :style="`${transition} width:${px2rem(width)}rem; height:${px2rem(height)}rem; ${activeStyle}`" class="active"></div>
          <!-- <img @click="onClickLottery" :style="lotteryStyle" class="sq_lott" :src="lottery"/> -->
      </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: [
    "prizePos",
    "delta",
    "value",
    "square",
    "priceList",
    "lottery",
    "squareLength",
    "lotteryStyle",
    "styleComp",
    "initDeg",
    "width",
    "height",
    "currentLeft",
    "currentTop",
    "activeStyle"
  ],
  data() {
    return {
      animate: false,
      indexLeftList:[0,1,2,2,2,1,0,0,0],
      indexTopList:[0,0,0,1,2,2,2,1],
      opts: {
        cyclesMin: 5 /* 转动圈数最小值 */,
        cyclesMax: 8 /* 转动圈数最大值 */,
      },
      list:[],
      offset: {
        x: 0,
        y: 0,
      },
      isFirstOper:true,
      current: 0,
      transition: "",
      deg: 0,
      circles: 0,
      squareDeg: 0,
      maxCircles: 0,
      timer: null,
      position: [0, 1, 2, 3, 4, 5, 6, 7],
    };
  },
  mounted() {
    this.transition = this.setTransition(0, 0);
    let list = [];
    [...new Array(this.squareLength)].forEach((item,index)=>{
      list.push({
        x:this.indexLeftList[index]*this.currentLeft,
        y:this.indexTopList[index]*this.currentTop,
      })
    })
    this.list = list;
  },
  watch: {
    value() {
      if (this.value) {
        this.isFirstOper = false;
        this.maxCircles = this.computedCircles();
        clearTimeout(this.timer);
        this.timer = null;
        this.animateFn();
      }
    },
  },
  methods: {
    px2rem(w){ 
      return w/37.5
    },
    animateFn() {
      this.timer = setTimeout(
        () => {
          clearTimeout(this.timer);
          if (this.circles < this.maxCircles) {
            let index = this.position[this.current];
            this.transition = this.setTransition(
              this.list[index].x,
              this.list[index].y
            );
            this.current = this.current < 7 ? this.current + 1 : 0;
            if (index == this.position.length - 1) {
              this.circles++;
            }
            this.animateFn();
          } else {
            let index = this.position[this.current];
            this.transition = this.setTransition(
              this.list[index].x,
              this.list[index].y
            );
            if (this.current == this.prizePos) {
              this.circles = 0;
              let timer = setTimeout(()=>{
                clearTimeout(timer);
                console.log("stop");
                this.$emit("success");
              },300)
              clearTimeout(this.timer);
              this.timer = null;
            }else{
              this.animateFn();
            }
            this.current = this.current < 7 ? this.current + 1 : 0;
          }
        },
        this.getDuration()
      );
    },
    getDuration(){
      if(this.circles<3){
        return 30
      }else if(this.circles<5){
        return 10+this.circles*10
      }else if(this.circles> this.maxCircles-1){
        return 250
      }else{
        return 10+this.circles*15
      }
    },
    computedCircles() {
      var min = this.opts.cyclesMin;
      var max = this.opts.cyclesMax;
      return Math.ceil(min + Math.random() * (max - min));
    },
    setList() {
      let offset = this.width + this.delta;
      let _list = [];
      for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
          _list.push({
            x: this.px2rem(col * offset),
            y: this.px2rem(row * offset),
          });
        }
      }
      return _list;
    },
    setTransition(x, y) {
      return `transition: all 0s ease 0s;transform: translate(${this.px2rem(x)}rem,${this.px2rem(y)}rem);`;
    },
    transtionEnd() {
      // console.log(this.prizePos);
      // this.$emit("input", false);
      // this.transition =
      //   "transition: none 0s ease 0s;transform: translate(" +
      //   this.squareDeg +
      //   "deg);";
      // /* 动画结束时恢复角度为360度以内 */
      // this.deg = this.deg % 360;
      // this.$emit("success", this.prizeList[this.prizePos]);
    },
    onClickLottery() {
      if (this.value) return; /* 已经在转的话点击不能起作用 */
      this.$emit("lottery");
    },
  },
});
</script>

<style lang="less" scoped="true">
.sq {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  &_box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
  &_img {
    height: 100%;
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
  }
  &_lott {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 53px;
    transform: translate(-50%, -50%);
    &:active {
      transform: translate(-50%, -50%) scale(0.95);
    }
  }
}
.square {
  overflow: hidden;
  width: 300px;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}
.active {
  position: absolute;
  left: 0;
  top: 0;
}
.box{
  position: absolute;
}
img{
  display: block;
}
</style>
